import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentProps } from 'react';
import { cx } from '@/cva.config';

export const Command = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive>) => (
  <CommandPrimitive
    className={cx(
      'flex size-full flex-col overflow-hidden bg-surface text-foreground',
      className,
    )}
    {...props}
  />
);

export const CommandInput = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive.Input>) => (
  <CommandPrimitive.Input
    className={cx(
      'flex-1 bg-transparent text-sm lg:text-base text-foreground outline-none placeholder:text-subtle',
      className,
    )}
    {...props}
  />
);

export const CommandList = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive.List>) => (
  <CommandPrimitive.List
    className={cx('max-h-[60vh] overflow-y-auto py-1.5', className)}
    {...props}
  />
);

export const CommandEmpty = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive.Empty>) => (
  <CommandPrimitive.Empty
    className={cx(
      'px-4 py-10 text-center font-mono text-xs lg:text-sm text-subtle',
      className,
    )}
    {...props}
  />
);

export const CommandGroup = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive.Group>) => (
  <CommandPrimitive.Group
    className={cx(
      'px-1.5 py-1',
      '**:[[cmdk-group-heading]]:px-3 **:[[cmdk-group-heading]]:py-1 **:[[cmdk-group-heading]]:font-mono **:[[cmdk-group-heading]]:text-2xs lg:**:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:tracking-[0.12em] **:[[cmdk-group-heading]]:text-subtle **:[[cmdk-group-heading]]:uppercase',
      className,
    )}
    {...props}
  />
);

export const CommandSeparator = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive.Separator>) => (
  <CommandPrimitive.Separator
    className={cx('-mx-1 my-1 h-px bg-border', className)}
    {...props}
  />
);

export const CommandItem = ({
  className,
  ...props
}: ComponentProps<typeof CommandPrimitive.Item>) => (
  <CommandPrimitive.Item
    className={cx(
      'group flex w-full cursor-default items-center gap-3 rounded-md px-3 py-2 text-left text-sm lg:text-base text-foreground transition-colors outline-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 data-[selected=true]:bg-accent-soft',
      className,
    )}
    {...props}
  />
);
